module.exports = __webpack_public_path__ + "media/ח.26607adb.mp3";